export default __webpack_public_path__ + "static/media/sign-placeholder-ua.e41b6ca1.png";